export default "__VITE_ASSET__Ddt905uy__"